export const GITHUB_URL = 'https://github.com/naamancurtis';
export const LINKEDIN_URL = 'https://www.linkedin.com/in/naamancurtis/';
